const Constant = {
    apiBaseUrl: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_DATADEX_BACKEND_API_URL : 'http://localhost:7789/api/',
    permissionTypes: ['edit', 'view', 'edit_all_children', 'view_all_children', 'edit_tag'],
    itemObjectTypes: ['datasource', 'database', 'table', 'field', 'dashboard'],
    itemObjectTypesPlural: ['datasources', 'databases', 'tables', 'fields', 'dashboards'],
}

export default Constant;


// WEBPACK FOOTER //
// ./src/constants/index.js